import { Navigate } from "react-router-dom";

import { useRouteHelpers } from "./helpers";

const DefaultRoute = () => {
  const { getDefaultRoute } = useRouteHelpers();
  return <Navigate to={getDefaultRoute()} />;
};

export default DefaultRoute;
